import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Login from "@/components/Login";
import ChangePassword from "@/components/changePassword";
import internalLogin from "@/components/internalLogin";
import Logout from "@/components/Logout";
import Signup from "@/components/Signup";
import Maintenance from "@/components/maintenance";
import Verify from "@/components/Verify";
import Book from "@/components/Book";
import Bookingsuccess from "@/components/Bookingsuccess";
import WithdrawalBookingSuccess from "@/components/Withdrawalbookingsuccess";

import Portal from "./views/Portal.vue";
import Terms from "./views/Terms.vue";
import Profile from "./views/Profile.vue";
import Notifications from "./views/Notifications.vue";
import Visa from "./views/services/Visa.vue";
import Alzaad from "./views/services/Alzaad.vue";
import Financial from "./views/services/Financial.vue";
import Account from "./views/services/Account.vue";
import Net from "./views/services/visa/Net.vue";
import Family from "./views/services/visa/Family.vue";
import Personal from "./views/services/visa/Personal.vue";
import Mobi from "./views/services/Mobi.vue";
import Mobile from "./views/services/Mobile.vue";
import Refund from "./views/services/Refund.vue";
import Closed from "./views/services/Closed.vue";
import Balancerequest from "@/components/requests/Balance.vue";
import CardRefund from "@/components/requests/CardRefund.vue";
import Cancelrequest from "@/components/requests/Cancelrequest.vue";
import MobiCashRefund from "@/components/requests/MobiCashRefund.vue";
import AtmRefund from "@/components/requests/AtmRefund.vue";
import PosRefund from "@/components/requests/PosRefund.vue";
import Servicerequest from "@/components/requests/Service";
import Servicerequestwithcard from "@/components/requests/Servicewithcard";
import Servicerequestwithotp from "@/components/requests/Servicewithotp";
import Chargerequest from "@/components/requests/Charge";
import chargerequestpersonal from "@/components/requests/Chargepersonal";
import MoneyGram from "@/components/requests/MoneyGram";
import Changepassword from "@/components/requests/Changepasswordwithotp";
import Statement from "@/components/requests/Statement.vue";
import Requestsinbox from "./views/Requestsinbox.vue";
import Requestinboxdetailed from "./views/Requestinboxdetailed.vue";
import Inbox from "./views/Inbox.vue";
import Withdrawal from "@/components/booking/withdrawal.vue";
import Fifa from "@/components/fifa.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
      meta: { requiresGuest: true },
    },
    {
      path: "/portal",
      name: "portal",
      component: Portal,
      meta: { requiresAuth: true },
    },
    {
      path: "/terms",
      name: "terms",
      component: Terms,
      meta: { requiresAuth: true },
    },
    {
      path: "/profile",
      name: "profile",
      component: Profile,
      meta: { requiresAuth: true },
    },
    {
      path: "/profile/changepassword",
      name: "changepassword",
      component: Changepassword,
      meta: { requiresAuth: true },
    },
    {
      path: "/orders",
      name: "inbox",
      component: Inbox,
      meta: { requiresAuth: true },
    },
    {
      path: "/notifications",
      name: "notifications",
      component: Notifications,
      meta: { requiresAuth: true },
    },
    {
      path: "/servicerequest",
      name: "servicerequest",
      component: Servicerequest,
      props: true,
      meta: { requiresAuth: true },
    },
    {
      path: "/cancelrequest/:requeststring/:requestid/:requesturl",
      name: "cancelrequest",
      component: Cancelrequest,
      props: true,
      meta: { requiresAuth: true },
    },
    {
      path: "/servicerequest/card",
      name: "servicerequestwithcard",
      component: Servicerequestwithcard,
      props: true,
      meta: { requiresAuth: true },
    },
    {
      path: "/servicerequest/otp",
      name: "Servicerequestwithotp",
      component: Servicerequestwithotp,
      props: true,
      meta: { requiresAuth: true },
    },
    {
      path: "/requests/inbox",
      name: "requestsinbox",
      component: Requestsinbox,
      props: true,
      meta: { requiresAuth: true },
    },
    {
      path: "/requests/inbox/view",
      name: "Requestinboxdetailed",
      component: Requestinboxdetailed,
      props: true,
      meta: { requiresAuth: true },
    },
    {
      path: "/chargerequest/family",
      name: "chargerequest",
      component: Chargerequest,
      props: true,
      meta: { requiresAuth: true },
    },
    {
      path: "/chargerequest/personal",
      name: "chargerequestpersonal",
      component: chargerequestpersonal,
      props: true,
      meta: { requiresAuth: true },
    },
    {
      path: "/chargerequest/MoneyGram",
      name: "MoneyGram",
      component: MoneyGram,
      props: true,
      meta: { requiresAuth: true },
    },
    {
      path: "/services/visa",
      name: "visa",
      component: Visa,
      meta: { requiresAuth: true },
    },
    {
      path: "/services/visa/net",
      name: "net",
      component: Net,
      meta: { requiresAuth: true },
    },
    {
      path: "/services/visa/family",
      name: "family",
      component: Family,
      meta: { requiresAuth: true },
    },
    {
      path: "/services/visa/personal",
      name: "personal",
      component: Personal,
      meta: { requiresAuth: true },
    },
    {
      path: "/services/financial",
      name: "financial",
      component: Financial,
      meta: { requiresAuth: true },
    },
    {
      path: "/services/closed",
      name: "Closed",
      component: Closed,
      meta: { requiresAuth: true },
    },
    {
      path: "/services/account",
      name: "account",
      component: Account,
      meta: { requiresAuth: true },
    },
    {
      path: "/services/mobicash",
      name: "Mobi",
      component: Mobi,
      meta: { requiresAuth: true },
    },
    {
      path: "/services/mobile",
      name: "Mobile",
      component: Mobile,
      meta: { requiresAuth: true },
    },
    {
      path: "/services/refund",
      name: "Refund",
      component: Refund,
      meta: { requiresAuth: true },
    },
    {
      path: "/services/refund/card",
      name: "CardRefund",
      component: CardRefund,
      meta: { requiresAuth: true },
    },
    {
      path: "/services/refund/mobicash",
      name: "MobiCashRefund",
      component: MobiCashRefund,
      meta: { requiresAuth: true },
    },
    {
      path: "/services/refund/atm",
      name: "AtmRefund",
      component: AtmRefund,
      meta: { requiresAuth: true },
    },
    {
      path: "/services/refund/pos",
      name: "PosRefund",
      component: PosRefund,
      meta: { requiresAuth: true },
    },
    {
      path: "/services/account/statement",
      name: "Statement",
      component: Statement,
      meta: { requiresAuth: true },
    },
    {
      path: "/services/account/balance",
      name: "Balance",
      component: Balancerequest,
      meta: { requiresAuth: true },
    },
    {
      path: "/services/tejwal",
      name: "tejwal",
      component: Alzaad,
      meta: { requiresAuth: true },
    },
    {
      path: "/services/booking/withdrawal",
      name: "withdrawal",
      component: Withdrawal,
      meta: { requiresAuth: true },
    },
    {
      path: "/login",
      name: "login",
      component: Login,
      props: true,
    },
    {
      path: "/changePassword",
      name: "changePassword",
      component: ChangePassword,
      props: true,
    },
    {
      path: "/internal/login/:token",
      name: "internalLogin",
      component: internalLogin,
    },
    {
      path: "/logout",
      name: "logout",
      component: Logout,
    },
    {
      path: "/verify/:id",
      name: "verify",
      component: Verify,
      meta: { requiresGuest: true },
    },
    {
      path: "/book",
      name: "book",
      component: Book,
      props: true,
      meta: { requiresGuest: true },
    },
    {
      path: "/fifa",
      name: "fifa",
      component: Fifa,
      meta: { requiresAuth: true },
      props: true,
    },
    {
      path: "/bookingsuccess",
      name: "bookingsuccess",
      component: Bookingsuccess,
      meta: { requiresGuest: true },
      props: true,
    },
    {
      path: "withdrawal/bookingsuccess",
      name: "withdrawalbookingsuccess",
      component: WithdrawalBookingSuccess,
      meta: { requiresAuth: true },
      props: true,
    },
    {
      path: "/signup",
      name: "signup",
      component: Signup,
      meta: { requiresGuest: true },
    },
    {
      path: "/maintenance",
      name: "maintenance",
      component: Maintenance,
      meta: { requiresGuest: true },
    },
    // ,
    // {
    //   path: '/about',
    //   name: 'about',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    // }
  ],
});
